import { render, staticRenderFns } from "./HatchingServiceDetail.vue?vue&type=template&id=02c19ab8&"
import script from "./HatchingServiceDetail.vue?vue&type=script&lang=js&"
export * from "./HatchingServiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports